import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-pink-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Chính sách bảo mật</h1>
        <p className="text-gray-600 mb-8">Cập nhật lần cuối: Tháng 3 năm 2026</p>

        <div className="prose prose-pink max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Giới thiệu</h2>
            <p className="text-gray-600">
              An Nhi ("chúng tôi", "của chúng tôi") cam kết bảo vệ quyền riêng tư của bạn. 
              Chính sách bảo mật này giải thích cách chúng tôi thu thập, sử dụng và bảo vệ 
              thông tin cá nhân của bạn khi sử dụng ứng dụng An Nhi.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Thông tin chúng tôi thu thập</h2>
            <div className="bg-pink-50 p-4 rounded-lg mb-4">
              <h3 className="text-lg font-medium text-pink-700 mb-2">Thông tin tài khoản:</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-1">
                <li>Địa chỉ email</li>
                <li>Mật khẩu (đã được mã hóa)</li>
                <li>Tuần mang thai hiện tại</li>
                <li>Ngày dự sinh</li>
              </ul>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg mb-4">
              <h3 className="text-lg font-medium text-blue-700 mb-2">Thông tin sức khỏe:</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-1">
                <li>Hồ sơ y tế và kết quả xét nghiệm</li>
                <li>Lịch khám thai</li>
                <li>Câu hỏi và câu trả lời với trợ lý AI</li>
              </ul>
            </div>
            <div className="bg-green-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium text-green-700 mb-2">Thông tin Facebook:</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-1">
                <li>Facebook PSID (Page-scoped ID)</li>
                <li>Cài đặt thông báo</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Cách chúng tôi sử dụng thông tin</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li><strong>Cung cấp dịch vụ:</strong> Cá nhân hóa trải nghiệm, lưu trữ lịch sử trò chuyện</li>
              <li><strong>Gửi thông báo:</strong> Nhắc nhở lịch khám thai, lời khuyên dinh dưỡng hàng ngày</li>
              <li><strong>Phân tích AI:</strong> Sử dụng Google Gemini AI để trả lời câu hỏi về sức khỏe thai kỳ</li>
              <li><strong>Cải thiện dịch vụ:</strong> Phân tích cách sử dụng để cải thiện ứng dụng</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Dịch vụ bên thứ ba</h2>
            <div className="bg-yellow-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium text-yellow-700 mb-2">Google Gemini AI</h3>
              <p className="text-gray-600">
                Chúng tôi sử dụng Google Gemini AI để cung cấp trả lời cho các câu hỏi về sức khỏe thai kỳ. 
                Câu hỏi của bạn được gửi đến máy chủ của Google để xử lý. 
                Xem chính sách bảo mật của Google tại: <a href="https://policies.google.com/privacy" className="text-blue-600 hover:underline">https://policies.google.com/privacy</a>
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg mt-4">
              <h3 className="text-lg font-medium text-blue-700 mb-2">Facebook Messenger</h3>
              <p className="text-gray-600">
                Nếu bạn liên kết tài khoản Facebook, chúng tôi sử dụng Facebook Messenger để gửi 
                thông báo và lời khuyên hàng ngày. Chúng tôi chỉ lưu trữ Facebook PSID, 
                không lưu trữ thông tin cá nhân từ Facebook.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Bảo mật dữ liệu</h2>
            <p className="text-gray-600">
              Chúng tôi thực hiện các biện pháp bảo mật sau:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mt-2">
              <li>Mã hóa mật khẩu bằng thuật toán băm an toàn</li>
              <li>Sử dụng HTTPS cho tất cả các kết nối</li>
              <li>Giới hạn quyền truy cập dữ liệu cho nhân viên</li>
              <li>Sao lưu dữ liệu thường xuyên</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Quyền của bạn</h2>
            <p className="text-gray-600 mb-4">Bạn có quyền:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li><strong>Truy cập:</strong> Yêu cầu bản sao dữ liệu cá nhân của bạn</li>
              <li><strong>Sửa đổi:</strong> Cập nhật hoặc chỉnh sửa thông tin không chính xác</li>
              <li><strong>Xóa bỏ:</strong> Yêu cầu xóa dữ liệu cá nhân của bạn</li>
              <li><strong>Ngưng sử dụng:</strong> Yêu cầu ngừng xử lý dữ liệu của bạn</li>
            </ul>
            <p className="text-gray-600 mt-4">
              Để thực hiện các quyền này, vui lòng liên hệ: <a href="mailto:caoanh0928@gmail.com" className="text-blue-600 hover:underline">caoanh0928@gmail.com</a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Lưu trữ dữ liệu</h2>
            <p className="text-gray-600">
              Dữ liệu được lưu trữ trên máy chủ của Render (Hoa Kỳ). Chúng tôi giữ dữ liệu của bạn 
              khi bạn còn sử dụng dịch vụ. Khi bạn xóa tài khoản, chúng tôi sẽ xóa dữ liệu trong 
              vòng 30 ngày.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Cookies và theo dõi</h2>
            <p className="text-gray-600">
              Chúng tôi sử dụng localStorage để lưu trữ thông tin đăng nhập và cài đặt người dùng. 
              Chúng tôi không sử dụng cookies hoặc công cụ theo dõi của bên thứ ba.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Thay đổi chính sách</h2>
            <p className="text-gray-600">
              Chúng tôi có thể cập nhật chính sách bảo mật này. Nếu có thay đổi lớn, chúng tôi sẽ 
              thông báo qua email hoặc trong ứng dụng.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Liên hệ</h2>
            <p className="text-gray-600">
              Nếu bạn có câu hỏi về chính sách bảo mật, vui lòng liên hệ:
            </p>
            <div className="bg-gray-100 p-4 rounded-lg mt-4">
              <p className="text-gray-800"><strong>An Nhi</strong></p>
              <p className="text-gray-600">Email: <a href="mailto:caoanh0928@gmail.com" className="text-blue-600 hover:underline">caoanh0928@gmail.com</a></p>
              <p className="text-gray-600">Website: <a href="https://annhi.site" className="text-blue-600 hover:underline">https://annhi.site</a></p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;